import React, { useState, useEffect, useRef } from "react";
import Players from "./components/players";
import Chart from "./components/chart";
import PlayingCards from "./components/playingCard";
import { compose } from "redux";
import { withSocket } from "../../socket/context";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import _, { stubArray } from "lodash";
import FlippedCardView from "./components/flippedCardView/index";
import ResultPage from "./components/resultPage/index";

const ChartyParty = (props) => {
  let roomData = _.get(props, "gameReducer.roomObj");
  let status = _.get(roomData, "game_state.status");
  const default_sound = _.get(props, "paramsReducer.gameObj.default_sound");
  const played_cards = _.get(roomData, "game_state.played_cards");
  const prev_played_cards = useRef();

  const playAudio = (url) => {
    var audio = document.createElement("audio");
    audio.src = url;
    audio.style.display = "none"; //added to fix ios issue
    audio.autoplay = true; //avoid the user has not interacted with your page issue
    audio.onended = function () {
      audio.remove(); //remove after playing to clean the Dom
    };
    document.body.appendChild(audio);
  };

  //return true if the flipped bit in played_card has been changed else return false
  const cardFlippedChanged = (prev_played_cards, played_cards) => {
    for (let i = 0; i < prev_played_cards.length; i++) {
      if (prev_played_cards[i]?.flipped !== played_cards[i]?.flipped) {
        return true;
      }
    }
    return false;
  };

  //play sound starting the game
  useEffect(() => {
    playAudio(default_sound);
  }, []);

  //play's sound when the status changes from pre-play to playing || playing to result || result to over
  useEffect(() => {
    if (status === "Playing") {
      playAudio(default_sound);
    } else if (status === "Result") {
      playAudio(default_sound);
    } else if (status === "Over") {
      playAudio(default_sound);
    }
  }, [status]);

  //plays sound when a card is played or flipped
  useEffect(() => {
    if (played_cards?.length > 0) {
      if (
        prev_played_cards?.current !== undefined &&
        prev_played_cards.current.length < played_cards.length
      ) {
        playAudio(default_sound);
      } else if (
        prev_played_cards?.current !== undefined &&
        cardFlippedChanged(prev_played_cards.current, played_cards)
      ) {
        playAudio(default_sound);
      }
    }
    prev_played_cards.current = played_cards;
  }, [played_cards]);

  return (
    <>
      {(status === "PrePlay" ||
        status === "Playing" ||
        status === "Evaluating") && (
        <div className="d-flex justify-content-between flex-column w-100 chpt-card-wrapper">
          <div className="chpt-card-1">
            <div className="chpt-card">
              {(status === "PrePlay" || status === "Playing") && <Chart />}
              {status === "Evaluating" && <PlayingCards />}
            </div>
          </div>
          <div className="chpt-card-2">
            <div className="chpt-card">
              <Players roomData={roomData} />
            </div>
          </div>
        </div>
      )}
      {status === "Reading" && <FlippedCardView />}
      {(status === "Result" || status === "Over") && <ResultPage />}
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default compose(
  withRouter,
  withSocket,
  connect(mapStateToProps, mapDispatchToProps)
)(ChartyParty);
